import { makeStyles, Theme } from "@material-ui/core";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

export default makeStyles((theme: Theme) => {
  const btnGroup: CSSProperties = {
    padding: 0,
    height: theme.spacing(3),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    fontSize: theme.typography.caption.fontSize,
    boxShadow: "none",
    alignItems: "end",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white
    }
  };

  return {
    loading: {
      marginTop: theme.spacing(10),
      display: "flex",
      justifyContent: "center",
      alignContent: "center"
    },
    section: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down("xs")]: {
        margin: theme.spacing(2)
      }
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2),

      [theme.breakpoints.down("xs")]: {
        width: "100%"
      }
    },
    closeButton: {
      color: theme.palette.grey[500]
    },

    btnGroupSelected: {
      ...btnGroup,
      fontWeight: theme.typography.fontWeightBold as number,
      borderColor: theme.palette.primary.dark,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      "&:first-child": {
        borderRightWidth: "1px",
        borderRightColor: theme.palette.primary.dark
      },
      "&.Mui-disabled": {
        color: theme.palette.common.white
      }
    },
    btnGroup: { ...btnGroup },
    activeSwitch: {
      "& .MuiFormControlLabel-label": {
        color: theme.palette.text.secondary,
        textTransform: "uppercase",
        fontSize: theme.typography.caption.fontSize
      }
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    helpTitle: {
      marginTop: "0.6rem",
      marginBottom: "1rem",
      color: theme.palette.text.secondary
    },
    gridField: {
      width: "100%"
    },
    gridHorizontalPad: {
      paddingRight: theme.spacing(2)
    }
  };
});
